<template>
    <div class="toolbar">
        <a-button type="link" @click="clearList">
            <template #icon>
                <!-- <DownloadOutlined /> -->
            </template>
            清空
        </a-button>
        <a-button type="link" @click="preview">
            <template #icon>
                <!-- <DownloadOutlined /> -->
            </template>
            预览
        </a-button>
        <a-button type="link" @click="importJson">
            <template #icon>
                <!-- <DownloadOutlined /> -->
            </template>
            导入JSON
        </a-button>
        <a-button type="link" @click="exportJson">
            <template #icon>
                <!-- <DownloadOutlined /> -->
            </template>
            导出JSON
        </a-button>
        <a-button type="link" @click="saveJson">
            <template #icon>
                <!-- <DownloadOutlined /> -->
            </template>
            保存模板
        </a-button>
        <a-modal title="预览" width="950" :visible="designer.visible" @cancel="handleCancel" :bodyStyle="{
                height: '480px',
                overflow: 'hidden',
                overflowY: 'scroll',
            }">
            <FormRender :formJsonObj="designer.previewJson" :formDataModel="designer.previewData" v-if="designer.visible"
                ref="formref" />
            <template #footer>
                <a-button @click="getPreviewData" type="primary">获取数据</a-button>
                <a-button @click="resetPreviewData" type="primary">重置表单</a-button>
                <a-button @click="setFormDisabled" type="primary">禁用/恢复</a-button>
                <a-button @click="handleCancel">关闭</a-button>
            </template>
        </a-modal>
        <a-modal :title="(designer.current == 'import' ? '导入' : '导出') + 'JSON'" width="550" :visible="designer.isEdit"
            @cancel="editCancel">
            <ace-editor v-model="designer.jsonModel" style="height: 350px;" mode="json" v-if="designer.isEdit"></ace-editor>
            <template #footer>
                <a-button @click="editOk" type="primary">{{ designer.current == 'import' ? '导入' : '复制' }}</a-button>
                <a-button @click="editCancel">取消</a-button>
            </template>
        </a-modal>
    </div>
</template>

<script setup>
import { ref, reactive, toRefs } from 'vue';
import FormRender from "../../form-render/index.vue";
import AceEditor from "../../ace-editor/ace-editor.vue";
import { deepClone } from '../../tools';
import http from "@/request/request";
import { message } from 'ant-design-vue';

const formref = ref(null)
const designer = reactive({
    formJson: {
        widgetList: [],
        formConfig: {
            labelWidth: 80,
            labelAlign: 'left',
            onFormMounted: '',
        },
    },
    visible: false,
    previewJson: {},
    previewData: {},
    isEdit: false,
    current: '',
    jsonModel: '',
})
const props = defineProps({
    formJsonObj: Object,
    saveFunction: Object,
})
const { formJsonObj, saveFunction } = toRefs(props)
const emits = defineEmits(["setDisabled", "clear", "setJson"]);

const getPreviewData = () => {
    console.log(designer.previewData)
}
const resetPreviewData = () => {
    designer.previewData = {}
}
const setFormDisabled = () => {
    formref.value.setDisabled()
}

const clearList = () => {
    emits("clear")
}
const preview = () => {
    designer.visible = true
    designer.previewJson = deepClone(formJsonObj.value)
    designer.previewData = {}
}
const handleCancel = () => {
    designer.visible = false
}
const editCancel = () => {
    designer.isEdit = false
}
const editOk = () => {
    if (designer.current == 'import') {
        emits("setJson", designer.jsonModel)
        designer.isEdit = false
    }
}
const importJson = () => {
    designer.current = 'import'
    designer.isEdit = true
    designer.jsonModel = JSON.stringify(designer.formJson)
}
const exportJson = () => {
    designer.current = 'export'
    designer.isEdit = true
    designer.jsonModel = JSON.stringify(formJsonObj.value)
}
const saveJson = () => {
    const saveApi = saveFunction.value
    if (!!saveApi && !!saveApi.path) {
        const config = {
            url: saveApi.path,
            method: saveApi.method || "get",
            [saveApi.method == 'post' ? 'data' : 'params']: saveApi.params,
        }
        http.request(config).then(res => {
            if (res.data.code == 200) {
                console.log("success");
            } else if (res.data.msg) {
                message.error(res.data.msg);
            }
        }).catch(err => message.error("请求失败", err))
    }
}
</script>

<style lang="scss" scoped>
.toolbar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
}
</style>